import {gsap} from "gsap";
import NavHeight from "../utils/nav-height";
import { lenis } from "../utils/ScrollLenis";

export default class NavResponsive {
    constructor() {

        const navHeight = new NavHeight();
        this.navHeightValue = navHeight.navHeightValue;
        this.scrollY = 0;
        this.init();

    }

    init() {

        this.initNavBurger();
        this.initResponsiveSubMenus()

    }

    // === BURGER ===
    initNavBurger() {
        const navBurgers = document.querySelectorAll(".burger");
        const navResponsive = document.querySelector(".nav-responsive");

        if (!navBurgers.length || !navResponsive) return;

        navBurgers.forEach(burger => {
            burger.addEventListener("click", () => {
                navBurgers.forEach(b => b.classList.toggle("active"));

                if (navResponsive.classList.contains("active")) {
                    gsap.to(navResponsive, {
                        duration: 0.5,
                        y: `-${this.navHeightValue}px`,
                        opacity: 0,
                        ease: "power2.inOut",
                        onComplete: () => {
                            if (lenis) lenis.start();
                            navResponsive.classList.remove("active");
                            document.documentElement.classList.remove("block-viewport");
                            document.body.classList.remove("block-viewport");
                            this.resetMenu();
                        }
                    });
                } else {
                    if (lenis) lenis.stop();
                    navResponsive.classList.add("active");
                    gsap.fromTo(navResponsive,
                        { y: `-${this.navHeightValue}px`, opacity: 0 },
                        {
                            duration: 0.5,
                            y: 0,
                            opacity: 1,
                            ease: "power2.inOut",
                            onStart: () => {
                                document.documentElement.classList.add("block-viewport");
                                document.body.classList.add("block-viewport");
                            }
                        }
                    );
                }
            });
        });
    }

    // === RESPONSIVE SUB MENU WITH PANELS ===
    initResponsiveSubMenus() {
        if (window.innerWidth >= 1200) return;

        const menuContainer = document.querySelector(".nav-responsive ul.menu-responsive");
        if (!menuContainer) return;

        document.querySelectorAll(".nav-responsive ul.menu-responsive > li.menu-responsive_item-has-children > a").forEach(link => {
            link.addEventListener("click", function (e) {
                e.preventDefault();
                const parentLi = this.closest("li.menu-responsive_item-has-children");
                const megaMenu = parentLi.querySelector(".megamenu-responsive");
                if (!megaMenu) return;

                megaMenu.classList.add("active");
                gsap.fromTo(megaMenu,
                    { x: "100%", opacity: 0 },
                    { x: "0%", opacity: 1, duration: 0.5, ease: "power2.inOut" }
                );
            });
        });

        document.querySelectorAll(".megamenu-responsive .sub-menu.level-0 > li.sub-menu_item-has-children > a").forEach(link => {
            link.addEventListener("click", function (e) {
                e.preventDefault();
                const parentLi = this.closest("li.sub-menu_item-has-children");
                const subMenuLevel1 = parentLi.querySelector(".sub-menu.level-1");
                if (!subMenuLevel1) return;

                subMenuLevel1.classList.add("active");
                gsap.fromTo(subMenuLevel1,
                    { x: "100%", opacity: 0 },
                    { x: "0%", opacity: 1, duration: 0.5, ease: "power2.inOut" }
                );
            });
        });

        // Ajouter les événements pour les boutons de retour
        document.querySelectorAll(".submenu-back").forEach(backButton => {
            backButton.addEventListener("click", function (e) {
                e.preventDefault();
                const parentMenu = this.closest(".megamenu-responsive, .sub-menu.level-1");
                if (!parentMenu) return;

                gsap.to(parentMenu, {
                    x: "100%",
                    opacity: 0,
                    duration: 0.5,
                    ease: "power2.inOut",
                    onComplete: () => {
                        parentMenu.classList.remove("active");
                    }
                });
            });
        });
    }


    // === RESET MENU ===
    resetMenu() {
        const activeMenus = document.querySelectorAll(".megamenu-responsive.active, .sub-menu.level-1.active");
        activeMenus.forEach(menu => {
            gsap.to(menu, {
                x: "100%",
                opacity: 0,
                duration: 0.5,
                ease: "power2.inOut",
                onComplete: () => {
                    menu.classList.remove("active");
                }
            });
        });
    }


}